import { memo } from "react";
import { TableItemId } from "../../../../../components/tables/TableWidget";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { TableItemType } from "../../../../../components/tables/tableContext/TableContext";
import { expeditionRoutes } from "../../../../../router/routesConstants";

function ExpeditionScheduleWorkingRoutesTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const goToOrganizeWorkingPoint = () => {
    return `/${expeditionRoutes.scheduleWorkingRoute}/${expeditionRoutes.organize}?id=${itemId}&ruta=${crudData?.denumire}`;
  };

  return (
    <div className="text-left">
      <ActionMenu
        minItemsForMenu={2}
        title={crudData?.denumire}
        ariaLabel={`Actiuni pentru ruta ${crudData?.denumire ?? ""}`}
        items={[
          {
            id: "organize",
            label: "Organizare",
            icon: "DOCUMENTS",
            tooltip:
              "Configureaza nodul, programul si optiunea de ruta internod.",
            navigate: goToOrganizeWorkingPoint(),
          },
        ]}
      />
    </div>
  );
}

export default memo(ExpeditionScheduleWorkingRoutesTableActionButtons);
